var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogActions = void 0;
var DialogActions_1 = __importDefault(require("./DialogActions"));
exports.DialogActions = DialogActions_1.default;
exports.default = DialogActions_1.default;
//# sourceMappingURL=index.js.map